import { createContext, useCallback, useEffect, useMemo, useState } from 'react'
import { getBusinessRules, saveBusinessRules } from '../services/businessRules.service'

const BusinessRulesContext = createContext(null)

export const BusinessRulesProvider = ({ children }) => {
  const [rules, setRules] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refetch = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getBusinessRules()
      setRules(data)
    } catch (e) {
      setError(e?.message || 'Error cargando reglas de negocio')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refetch()
  }, [refetch])

  const update = useCallback(async (nextRules) => {
    await saveBusinessRules(nextRules)
    setRules(nextRules)
  }, [])

  const value = useMemo(() => ({
    rules,
    loading,
    error,
    refetch,
    update
  }), [rules, loading, error, refetch, update])

  return (
    <BusinessRulesContext.Provider value={value}>
      {children}
    </BusinessRulesContext.Provider>
  )
}

export default BusinessRulesContext

